"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ulrich = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
class Ulrich extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.ULRICH,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L21',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.opgArrow().oceans(1).colon().megacredits(4).multiplier.slash().megacredits(16).asterix();
                }),
                description: 'Once per game, gain 4 M€ for each ocean placed. If all oceans are aleady placed, gain only 16 M€.',
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct() {
        return this.isDisabled === false;
    }
    action(player) {
        const game = player.game;
        if (game.noOceansAvailable()) {
            player.addResource(Resources_1.Resources.MEGACREDITS, 16, { log: true });
        }
        else {
            const oceansPlaced = game.board.getOceansOnBoard();
            player.addResource(Resources_1.Resources.MEGACREDITS, oceansPlaced * 4, { log: true });
        }
        this.isDisabled = true;
        return undefined;
    }
}
exports.Ulrich = Ulrich;
//# sourceMappingURL=Ulrich.js.map